/**
 * @author MadhuSudhan
 * @Date: 2023-10-12 15:07:51
 * @Last Modified by: madhusudhan
 * @Last Modified time: 2023-10-18 13:32:19
 */

import { createStructuredSelector } from 'reselect';
import { func, shape, bool, string, number } from 'prop-types';
import { blockYscCard } from './actions';
import { submitOtp } from '../PayBalance/actions';
import { resetPopup } from '../HeaderContainer/actions';
import { isLoading, select_otp_response } from '../PayBalance/selectors';
import { select_CardAction } from './selectors';
import { select_cardBlockJS, select_card_data, select_isBoolean } from '../NetworkCards/selectors';
import { blockCard, fetchCardData, initPosPinReset, unlockCard } from '../NetworkCards/actions';

const YscCardActionsProps = {
  isLoadStatus: bool.isRequired,
  isLoadingStatus: bool.isRequired,
  LockCardOtpSuccess: shape({}).isRequired,
  UnlockCardOtpSuccess: shape({}).isRequired,
  match: shape({
    params: shape({
      id: string,
      type: string,
    }),
  }).isRequired,
  cardData: shape({}).isRequired,
  BlockCardOtpSuccess: shape({}).isRequired,
  BlockCardSuccess: shape({}).isRequired,
  LockCardSuccess: shape({}).isRequired,
  UnlockCardSuccess: shape({}).isRequired,
  history: shape({}).isRequired,
  location: shape({}).isRequired,
  onFetchCardData: func.isRequired,
  onInitPosPinReset: func.isRequired,
  onResetPopup: func.isRequired,
  oninitBlockYscCard: func.isRequired,
  onBlockCard: func.isRequired,
  onUnlockCard: func.isRequired,
  onInitSubmitOtp: func.isRequired,
};


const mapDispatchToProps = (dispatch) => ({
  onFetchCardData: (payload) => dispatch(fetchCardData(payload)),
  onInitPosPinReset: (payload, otherParams) => dispatch(initPosPinReset(payload, otherParams)),
  onResetPopup: (payload, actionType, alertType) => dispatch(resetPopup(payload, actionType, alertType)),
  oninitBlockYscCard: (payload) => dispatch(blockYscCard(payload)),
  onBlockCard: (payload) => dispatch(blockCard(payload)),
  onUnlockCard: (payload) => dispatch(unlockCard(payload)),
  onInitSubmitOtp: (payload) => dispatch(submitOtp(payload)),
});

const mapStateToProps = createStructuredSelector({
  cardData: select_card_data(),
  BlockCardOtpSuccess: select_CardAction('blockCardOtpSuccess'),
  LockCardOtpSuccess: select_cardBlockJS('isOtpSend'),
  UnlockCardOtpSuccess: select_cardBlockJS('unlockCardOtpSuccess'),
  BlockCardSuccess: select_CardAction('blockCardSuccess'),
  UnlockCardSuccess: select_otp_response('otp_response'),
  isLoadingStatus: select_isBoolean('isLoading'),
  LockCardSuccess: select_otp_response('otp_response'),
  isLoadStatus: isLoading(),
});

const CardActionsProps = {
  isLoadStatus: bool.isRequired,
  isLoadingStatus: bool.isRequired,
  showResendText: bool.isRequired,
  type: string.isRequired,
  MobileNumber: string.isRequired,
  OTP: string.isRequired,
  remainingTime: number.isRequired,
  handleOtpChange: func.isRequired,
  handleResendOTP: func.isRequired,
  verifyLockCardOTP: func.isRequired,
  verifyUnlockCardOTP: func.isRequired,
  verifyBlockCardOTP: func.isRequired,
};

export { YscCardActionsProps, mapStateToProps, mapDispatchToProps, CardActionsProps };



// WEBPACK FOOTER //
// client/containers/YscCardActions/YscCardActionsDataHandler.js